// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__jk5V8","notes":"Notes_notes__2wB50","note":"Notes_note__vnmLG","markdown":"Notes_markdown__1WJi7"};